import { useTranslation } from "react-i18next";

/**
 * Empty-cart infographic (KAN-420).
 *
 * Sits between ``PageHero`` and the upload card, replacing the small
 * caption that used to live inside the card. The illustration is a
 * deliberately abstract outline of a workshop space — walls, a
 * workbench, a shelf, a window — carrying atmosphere, not inventory:
 * per ``docs/GENERIC_PLATFORM.md`` it must not name a process or a
 * machine, since the platform also serves tenants with none. The text
 * carries the message (``aria-hidden`` on the SVG); the drawing is
 * decoration.
 */
export function EmptyCartHero(): JSX.Element {
  const { t: tCart } = useTranslation("cart");

  return (
    <div className="mb-8 flex flex-col items-center gap-4 text-center">
      <svg
        width="180"
        height="120"
        viewBox="0 0 180 120"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
        className="text-ink-3"
      >
        {/* room outline */}
        <path d="M10 110 H170" />
        <path d="M10 110 V20 H170 V110" />
        {/* window */}
        <rect x="120" y="34" width="34" height="34" />
        <path d="M137 34 V68 M120 51 H154" />
        {/* shelf on the back wall */}
        <path d="M22 40 H74" />
        <path d="M30 40 V46 M46 40 V46 M62 40 V46" />
        {/* workbench */}
        <path d="M20 96 H90 V78 H20 Z" />
        <path d="M26 96 V106 M84 96 V106" />
      </svg>
      <p className="text-xl font-medium text-ink-2">{tCart("empty")}</p>
    </div>
  );
}
